import { Button, Card } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { LogTableRow } from '../../../../../hooks/api/logs';

interface LogExpandedRowProps {
  record: LogTableRow;
}

function downloadEmailsFile(
  emails: string[],
  fileName = 'emails.txt',
) {
  const blob = new Blob(
    [emails.join('\n')],
    { type: 'text/plain;charset=utf-8' },
  );

  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');

  link.href = url;
  link.download = fileName;

  document.body.append(link);

  link.click();

  link.remove();

  URL.revokeObjectURL(url);
}

export default function EmailsLogContent({
  record,
}: LogExpandedRowProps) {
  const after = record.after as {
    emails?: string;
    emailType?: string;
  };

  const emails = after?.emails
    ?.split(',')
    .map((email) => email.trim())
    .filter(Boolean) || [];

  const visibleEmails = emails.slice(0, 10);
  const hasMoreEmails = emails.length > 10;

  return (
    <Card size="small" title="Sent emails">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
        }}
      >
        <div>
          <strong>Email type:</strong>
          {' '}
          {after.emailType}
        </div>

        <div>
          <strong>Total emails:</strong>
          {' '}
          {emails.length}
        </div>

        {/** Show emails: */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            padding: 12,
            borderRadius: 8,
            background: '#141414',
            color: '#fff',
            fontFamily: 'monospace',
            fontSize: 12,
          }}
        >
          {visibleEmails.map((email) => (
            <div key={email}>
              {email}
            </div>
          ))}

          {hasMoreEmails && (
            <div
              style={{
                marginTop: 8,
                opacity: 0.7,
                fontStyle: 'italic',
              }}
            >
              You can see the full list in the downloaded file.
            </div>
          )}
        </div>

        <Button
          icon={<DownloadOutlined />}
          type="primary"
          onClick={() => downloadEmailsFile(emails)}
          style={{ width: 'min-content' }}
        >
          Download emails .txt
        </Button>
      </div>
    </Card>
  );
}
